import { render } from "./AdminTrack25Liquidation.vue?vue&type=template&id=1671ef9c"
import script from "./AdminTrack25Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminTrack25Liquidation.vue?vue&type=script&lang=js"

import "./AdminTrack25Liquidation.vue?vue&type=style&index=0&id=1671ef9c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__